<template>
    <div v-show="opened" class="backLayer">
        <div class="window" v-bind:style="height ? 'height:' + height +'px':''">
            <div class="title">
                <span>{{ title }}</span>
                <auto-icon src="/icon/all_popup_icon_delete" @click="close()" style="display: inline-block; float: right; vertical-align: middle; margin-right: 30px; line-height: 50px;"></auto-icon>
            </div>
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .backLayer {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(6, 19, 43, 0.40);
    }

    .window {
        width: 580px;
        height: 320px;
        border-radius: 4px;
        background: white;
        top: 50%;
        left: 50%;
        margin-left: -290px;
        margin-top: -160px;
        position: absolute;
        display: flex;
        flex-direction: column;
    }

    .title {
        background: #367eff;
        height: 50px;
        color: white;
        font-size: 0;
        border-radius: 4px 4px 0 0;
    }

    .title span {
        font-family: PingFangSC-Regular;
        font-size: 20px;
        color: #FFFFFF;
        margin-left: 36px;
        line-height: 50px;
    }

    .content {
        flex: 1;
    }

</style>
<script>
    import AutoIcon from '../components/AutoIcon.vue'

    export default {
        components: { AutoIcon },
        props: ['title', 'height'],
        data() {
            return {
                opened: false
            }
        },
        methods: {
            open() {
                this.opened = true;
            },
            close() {
                this.opened = false;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/ModalDialog.vue